module.exports = __webpack_public_path__ + "static/media/marker-atlas.c85e151b.png";